import Swal from "sweetalert2";

export const escapeHtml = (value) =>
  String(value ?? "-")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export const externalLink = (url, label) => {
  const raw = String(url || "").trim();
  if (!raw || raw === "-") return "-";

  const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  const text = label || raw;

  return `<a class="bls-detail-link" href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(text)}</a>`;
};

const detailValue = (row) => {
  if (row.html) return row.html;
  return escapeHtml(row.value).replace(/\n/g, "<br/>");
};

export const showDetailModal = ({ title, rows }) => {
  const body = rows
    .map(
      (row) => `
        <div class="bls-detail-row">
          <span class="bls-detail-label">${escapeHtml(row.label)}</span>
          <span class="bls-detail-value">${detailValue(row)}</span>
        </div>
      `
    )
    .join("");

  return Swal.fire({
    title: title || "Details",
    html: `<div class="bls-detail-list">${body}</div>`,
    confirmButtonText: "Close",
    confirmButtonColor: "#21146b",
    customClass: {
      popup: "bls-detail-modal",
      title: "bls-detail-modal-title",
      htmlContainer: "bls-detail-modal-body",
    },
  });
};
